import dayjs from "../config/dayjs";

export const formatDate = (input: string | Date | null | undefined) => {
  if (!input) return "";
  const date = dayjs(input);
  return date.isValid() ? date.format("DD-MM-YYYY") : String(input);
};
